import { gql } from "@apollo/client";

const schema = {
  create: {
    name: "createUnit",
    serviceName: "admin",
    query: gql`
      mutation createUnit(
        $type: String
        $title: String!
        $alias: String
        $lat: String
        $lng: String
        $city: String
        $state: String
        $is_active: Int
        $manager_id: String
      ) {
        createUnit(
          type: $type
          title: $title
          alias: $alias
          lat: $lat
          lng: $lng
          city: $city
          state: $state
          is_active: $is_active
          manager_id: $manager_id
        ) {
          messages
        }
      }
    `,
  },
};

export default schema;
